import { RefObject, useEffect, useState } from 'react';

const useSize = <T extends HTMLElement>(ref: RefObject<T>): DOMRectReadOnly => {
  const [size, setSize] = useState<DOMRectReadOnly>(new DOMRectReadOnly());

  useEffect(() => {
    if (ref.current === null) return;

    const observer = new ResizeObserver(([entry]) => setSize(entry.contentRect));

    observer.observe(ref.current);

    return (): void => observer.disconnect();
  }, []);

  return size;
};

export default useSize;
